export const getRefundType = (isLetting: boolean, separator = ' ') => {
  return (isLetting ? ['letting', 'income'] : ['site', 'fees'])
    .concat('refund')
    .join(separator);
};
